import { reportsListStore } from '../stores/reports/ReportsListStore';
import ReportsApi from '../../../../api/2bap/2bapReportsApi';
import Dispatcher from '../../../../dispatcher/appDispatcher';
import ActionType from '../../../../constants/actionType';
import { find } from 'lodash';

class ReportsDictionary {

  static ALL_REPORTS_CATEGORY_ID = -2;

  static FAVOURITE_REPORTS_CATEGORY_ID = -1;

  /**
   * @type {Promise<*>}
   */
  get dictionary() {
    if (!this._dictionary) {
      this._dictionary = this._getReportsDictionary();
    }
    return this._dictionary;
  }

  _dictionary;

  async resolveReportName(reportType) {
    const reports = await this.dictionary;
    const report = find(reports, { code: reportType });
    return report && report.title;
  }

  async resolveReportType(reportType) {
    const reports = await this.dictionary;
    const report = find(reports, { code: reportType });
    return report && report.code;
  }

  async validateReportType(reportType) {
    const reports = await this.dictionary;
    const report = find(reports, { code: reportType });
    return Boolean(report);
  }

  async _getReportsDictionary() {
    if (reportsListStore.allReports) {
      return reportsListStore.allReports;
    }

    const reports = (await ReportsApi.getReportList(ReportsDictionary.ALL_REPORTS_CATEGORY_ID)).list;

    Dispatcher.dispatch({
      actionType: ActionType.BUILD_A_PROFILE_MODULE_REPORTS_LIST_PAGE_GET_GLOBAL_REPORTS_LIST,
      reports
    });

    return reports;
  }

}

export const reportsDictionary = new ReportsDictionary();
